var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"no-print pl-0",attrs:{"items":_vm.items,"large":_vm.large,"divider":_vm.divider},scopedSlots:_vm._u([(_vm.customDiv)?{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }